import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Page from '../../../components/Structure/Layouts/Page';
import { actionTypes } from '../../../store/actions';
import system_translations from '../../../texts/system_translations';
import SimpleTable from './components/SimpleTable';
import EditMembershipDateModal from './modals/EditMembershipDateModal';
import useBrandsView from './useBrandsView';



const BrandsView = ({user, history, language}) => {

    const content = system_translations[language].views.brands
    const {system, view_data, actions, modals } = useBrandsView({user})

    return ( 
        <div style={{minHeight:'100vh'}}>
            <Page title={content.title} >
                {/* <AddUserModal open={modals.add_register} onSubmit={actions.onSubmit} actions={actions}
                onClose={() => actions.onUpdateModalStatus('add_register', false)} user={user}/> */}
                <EditMembershipDateModal open={modals.edit_membership_date} onClose={()=>actions.onUpdateModalStatus('edit_membership_date', false)} 
                    origin={view_data.selectedItem} actions={actions} />
                <div>
                    <SimpleTable 
                        content={content.table}
                        loading={system.loading || system.sending}
                        data={view_data.data} 
                        filter={view_data.filter}
                        tableFilter={view_data.tableFilter}
                        total={view_data.total} 
                        onSelectedItem={(item) => console.log(item)}
                        onAddRegister={() => actions.onUpdateModalStatus('add_register', true)}
                        onUpdateTableFilter={actions.onUpdateTableFilter}
                        onChangeFilter={actions.onChangeFilter} 
                        onChangeSearch={actions.onChangeSearch}
                        onChangeStatuses={actions.onChangeManagerStatuses}
                        onEditMembershipDate={actions.onEditMembershipDate}
                        />
                </div>
            </Page>
        </div>  
     );
}

const mapStateToProps = (state) => {
    return {
        user:state.user,
        language:state.language
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onUpdateCart: (cart) => dispatch({type:actionTypes.ECO_UPDATE_CART, cart})
    }
}
 
export default connect(mapStateToProps, mapDispatchToProps)(BrandsView);